import { render, staticRenderFns } from "./select-house-building.vue?vue&type=template&id=51e773a2"
import script from "./select-house-building.vue?vue&type=script&lang=ts"
export * from "./select-house-building.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports